import React, { useState } from "react";
import { TagFieldInput } from "../TagFieldInput/TagFieldInput";
import { toCamelCase } from "../../utils/string";
import "./DynamicTagFields.css";

export function DynamicTagFields({
   metadata,
   setMetadata,
   withWrapper = true,
   ...props
}) {
   let fields = [];

   if (props.unit?.tags) {
      for (const tag of props.unit.tags) {
         if (tag.schema && tag.schema.length > 0) {
            fields = [
               ...fields,
               ...tag.schema,
            ];
         }
      }
   }

   if (props.tag?.schema && props.tag.schema.length > 0) {
      const newFields = props.tag.schema.filter(field => !fields.some(f => f.name === field.name));
      fields = [
         ...fields,
         ...newFields,
      ];
   }

   if (!fields || fields.length === 0) {
      return null;
   }

   function mountFields() {
      return fields.map(field => (
         <div className={`${fields.length > 1 ? 'col-span-1' : 'col-span-2'}`}>
            <TagFieldInput
               key={field.id ?? toCamelCase(field.name)}
               fieldConfig={field}
               value={metadata?.find(mItem => mItem.name === toCamelCase(field.name))?.value ?? field.defaultValue}
               onChange={(newValue) => setMetadata(prevMeta => {
                  const newMeta = [...prevMeta];
                  const fieldIdx = newMeta.findIndex(mItem => mItem.name === toCamelCase(field.name));

                  if (fieldIdx === -1) {
                     newMeta.push({ name: toCamelCase(field.name), value: newValue });
                  } else {
                     newMeta[fieldIdx] = { name: toCamelCase(field.name), value: newValue };
                  }

                  return newMeta;
               })}
            />
         </div>
      ));
   }

   return (
      withWrapper ?
         <div className="grid-2">
            {mountFields()}
         </div>
         : mountFields()
   );
}